import { DataSource } from 'hooks/useHttpClient';
import { FactAudit, SelectItemType } from './Common';
import { BasicMappedStatus } from './Candidate';

export const FeedbackTypes: BasicMappedStatus[] = [
    { id: 1, name: 'General' },
    { id: 2, name: 'Attitude' },
    { id: 3, name: 'Soft Skills' },
    { id: 4, name: 'Quality' },
    { id: 5, name: 'Technical' },
    { id: 6, name: 'Communication' },
    { id: 7, name: 'Cultural' }
];

export type ShortTeamMember = {
    id: number;
    fullName: string;
    startDate: string;
    jobId: number;
    jobTitle?: string;
};

export type TeamByJob = {
    id: number;
    name: string;
    members: ShortTeamMember[];
};

export type MemberFeedback = {
    id: number;
    rate: number;
    comment: string;
    createdBy: FactAudit;
    type: BasicMappedStatus;
};

export type FullTeamMember = {
    id: number;
    averageRate: number;
    feedback: MemberFeedback[];
    fullName: string;
    startDate?: string | null;
    email?: string | null;
    employeeEmail?: string | null;
    phone?: string | null;
    location?: string | null;
};

export function GetFullTeamMemberResolver(dataSource: DataSource, member: any): FullTeamMember | null {
    try {
        switch (dataSource) {
            case 'hyrerocket': {
                const feedback: MemberFeedback[] = [];
                Object.keys(member.feedbacks).forEach((key) => {
                    member.feedbacks[key].forEach((item: any) => {
                        feedback.push({
                            id: item.id,
                            rate: item.rate,
                            comment: item.comment,
                            createdBy: {
                                userId: item.user?.id || 0,
                                dateStr: item.created_at,
                                userFullName: item.user?.name || '',
                                avatar: item.user?.profile?.profile_picture || ''
                            },
                            type: FeedbackTypes.find((type) => type.id === item.type_id) || FeedbackTypes[0]
                        });
                    });
                });
                return {
                    id: member.candidate.id,
                    averageRate: feedback.length > 0 ? feedback.reduce((a, b) => a + b.rate, 0) / feedback.length : 0,
                    feedback,
                    fullName: `${member.candidate.first_name} ${member.candidate.last_name}`,
                    startDate: member.start_date, // NOT WORKING
                    email: member.candidate.email,
                    employeeEmail: member.candidate.employee_email,
                    phone: member.candidate.phone,
                    location: member.candidate.location
                };
            }
            default:
                return null;
        }
    } catch (error) {
        console.log('GetFullTeamMemberResolver', error, member);
        return null;
    }
}

export function GetCompanyOptionsResolver(dataSource: DataSource, companies: any): SelectItemType[] {
    try {
        switch (dataSource) {
            case 'hyrerocket': {
                const companyOptions: SelectItemType[] = [];
                companies.forEach((company: any) => {
                    companyOptions.push({
                        label: company.name,
                        value: company.id
                    });
                });
                return companyOptions;
            }
            default:
                return [];
        }
    } catch (error) {
        return [];
    }
}

export function GetCompanyStatusResolver(dataSource: DataSource, companies: any): BasicMappedStatus[] {
    try {
        switch (dataSource) {
            case 'hyrerocket': {
                const companyOptions: BasicMappedStatus[] = [];
                companies.forEach((company: any) => {
                    companyOptions.push({
                        name: company.name,
                        id: company.id
                    });
                });
                return companyOptions;
            }
            default:
                return [];
        }
    } catch (error) {
        console.log('GetCompanyStatusResolver', error, companies);
        return [];
    }
}

export function GetTeamByJobResolver(dataSource: DataSource, teams: any): TeamByJob[] {
    try {
        switch (dataSource) {
            case 'hyrerocket': {
                const teamByJob: TeamByJob[] = [];
                teams.forEach((team: any) => {
                    const members: ShortTeamMember[] = [];
                    team.candidates.forEach((member: any) => {
                        members.push({
                            id: member.id,
                            fullName: `${member.first_name} ${member.last_name}`,
                            startDate: member.start_date,
                            jobId: team.id,
                            jobTitle: team.title
                        });
                    });
                    teamByJob.push({
                        id: team.id,
                        name: team.title,
                        members
                    });
                });
                return teamByJob;
            }
            default:
                return [];
        }
    } catch (error) {
        console.log('GetTeamByJobResolver', error, teams);
        return [];
    }
}
